/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaginationData, PostManagementData } from '@/Interfaces/I_postManagement';
import { ChannelData } from '@/Interfaces/I_vod';
import { VersionData } from '@/Interfaces/common';

export const vodSlice = createSlice({
  name: 'vodSlice',
  initialState: {
    value: {
      channels: [] as ChannelData[],
      channelVersion: 0 as number,
      selectedChannel: {} as ChannelData,
      post: {
        data: [] as PostManagementData[],
        pagination: {} as PaginationData,
      },
    },
    loading: false,
    error: '',
  },
  reducers: {
    getAllChannel: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setAllChannel: (state, action: PayloadAction<VersionData<ChannelData[]>>) => {
      const assignState = state;
      const updatedSelected = action.payload.data.find(
        (ch) => ch.channelId === assignState.value.selectedChannel.channelId,
      );
      assignState.value = {
        ...assignState.value,
        channels: action.payload.data,
        channelVersion: action.payload.version,
        ...(updatedSelected ? { selectedChannel: updatedSelected } : {}),
      };
      assignState.loading = false;
    },
    setSelectedChannel: (state, action) => {
      const assignState = state;

      const selectedChannelData =
        assignState.value.channels.find((channel) => channel.channelId === action.payload) ||
        ({} as ChannelData);
      assignState.value = { ...assignState.value, selectedChannel: selectedChannelData };
    },
    postChannelPost: (_state, _action) => {},
    postChannelPostSuccess: (state, action) => {
      const assignState = state;
      const { channelId, postUuid } = action.payload;

      if (channelId === assignState.value.selectedChannel.channelId) {
        postUuid.forEach((uuid: string) => {
          const postIdx = assignState.value.post.data.findIndex((post) => post.uuid === uuid);
          assignState.value.post.data[postIdx].channelPinned = true;
        });
      }
    },
    deleteChannelPost: (_state, _action) => {},
    deleteChannelPostSuccess: (state, action) => {
      const assignState = state;
      const { channelId, postUuid } = action.payload;

      if (channelId === assignState.value.selectedChannel.channelId) {
        postUuid.forEach((uuid: string) => {
          const postIdx = assignState.value.post.data.findIndex((post) => post.uuid === uuid);
          assignState.value.post.data[postIdx].channelPinned = false;
        });
      }
    },
    getChannelCategory: (state, _action) => {
      const assignState = state;
      assignState.loading = true;
    },
    getVodPost: (state, _action) => {
      const assignState = state;
      assignState.loading = true;
    },
    setVodPost: (state, action) => {
      const assignState = state;
      assignState.value = { ...assignState.value, post: action.payload.data };
      assignState.loading = false;
    },
    createChannel: (state, _action) => {
      const assignState = state;
      assignState.loading = true;
    },
    createChannelSuccess: (state, action: PayloadAction<VersionData<ChannelData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        channels: action.payload.data,
        channelVersion: action.payload.version,
      };
      assignState.loading = false;
    },
    updateChannels: (state, _action) => {
      const assignState = state;
      assignState.loading = true;
    },
    unpinAllChannelPost: (state, _action) => {
      const assignState = state;
    },
    resequenceChannelPosts: (_state, _action) => {},
    resequenceChannelPostsSuccess: (state) => {
      const assignState = state;
      assignState.loading = false;
    },
    updateChannelsSuccess: (state, action: PayloadAction<VersionData<ChannelData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        channels: action.payload.data,
        channelVersion: action.payload.version,
      };
      assignState.loading = false;
    },
    failure: (state, action) => {
      const assignState = state;
      assignState.loading = false;
      assignState.error = action.payload;
    },
  },
});

export const {
  getAllChannel,
  setAllChannel,
  setSelectedChannel,
  postChannelPost,
  postChannelPostSuccess,
  deleteChannelPost,
  deleteChannelPostSuccess,
  getChannelCategory,
  getVodPost,
  setVodPost,
  createChannel,
  createChannelSuccess,
  updateChannels,
  updateChannelsSuccess,
  unpinAllChannelPost,
  resequenceChannelPosts,
  resequenceChannelPostsSuccess,
  failure,
} = vodSlice.actions;

export default vodSlice.reducer;
